
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LoadingState } from "@/components/error-handling/LoadingState";

export const MatchingCandidatesLoadingState = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Matching Candidates</CardTitle>
      </CardHeader>
      <CardContent>
        <LoadingState message="Finding best matches..." />
      </CardContent>
    </Card>
  );
};
